import axios from 'axios';

export const VueHttp = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        'clickncoll-api-key': process.env.VUE_APP_API_KEY,
    }
})